import React from 'react';
import { Card, CardImg,CardBody,CardTitle  } from 'reactstrap';
import PropTypes from 'prop-types'

const UnionCard = (props) => (
  <Card className="UnionCard" onClick={() => props.onClick(props.unionid)}>
    <div className="UnionOverviewHeader">
      <CardImg top className="UnionOverviewLogo" src={"/img/"+props.unionid.toLowerCase() + "logo.png"} alt={props.unionid + " Logo"} />
    </div>
    <CardBody>
      <CardTitle>
        {props.description}
      </CardTitle>
    </CardBody>
  </Card>
);

UnionCard.propTypes = {
  unionid: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

export default UnionCard



// WEBPACK FOOTER //
// ./src/union/UnionCard.jsx